import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import TeamRoster from '../../components/TeamRoster';
import { apiGet } from '../../../services/apiFetch';
import '../../../styles/TeamDetails.css';

const TeamDetails = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [team, setTeam] = useState(null);
    const [loading, setLoading] = useState(true);
    const [roster, setRoster] = useState([]);

    useEffect(() => {
        const fetchPlayer = async () => {
            try {
                const { data: teamJson, error: teamErr } = await apiGet(`/api/rl/teams/${id}`);
                if (teamErr) throw new Error(teamErr.error);
                const team = teamJson.team;
                console.log(team);
                setTeam(team);
                const { data: playersJson, error: playersErr } = await apiGet(`/api/rl/teams/${id}/players?player_ids=${team.player_ids}`);
                if (playersErr) throw new Error(playersErr.error);
                const players = playersJson.players;
                console.log(players);
                setRoster(players);
            } catch (err) {
                console.error('Error fetching team:', err);
            } finally {
                setLoading(false);
            }
        };
        fetchPlayer();
    }, [id]);

    if (loading) return <div className="spinner"></div>;
    if (!team) return <div className="no-results">Team not found</div>;

    return (
        <div className="team-details">
            <div className="admin-team-header">
                <div className='team-form-buttons'>
                    <button onClick={() => navigate(-1)} className="back-button">
                        ← Back
                    </button>
                    <div className='team-form-buttons-right'>
                        <Link to={`/admin/teams/edit/${id}`} className="basic-button" state={{ team }}>
                            Edit Profile
                        </Link>
                    </div>
                </div>
                <div className="team-profile-section">
                    <div className="team-info">
                        <div className="team-info-item team-name-with-image">
                            <div className="team-profile-image">
                                <img
                                    src={team.image || '/assets/images/placeholder.png'}
                                    alt={team.name}
                                    className="team-logo-detail"
                                    onError={e => (e.target.src = '/assets/images/placeholder.png')}
                                />
                            </div>
                            <div className="team-name-content">
                                <span className="info-label">Team Name</span>
                                <span className="info-value">{team.name}</span>
                            </div>
                        </div>
                        <div className="team-info-item">
                            <span className="info-label">Website</span>
                            <span className="info-value">{team.website || '-'}</span>
                        </div>
                        <div className="team-info-item">
                            <span className="info-label">Country</span>
                            <span className="info-value">{team.country || '-'}</span>
                        </div>
                    </div>
                </div>
            </div>
            <TeamRoster playerData={roster} />
        </div>

    );
};

export default TeamDetails;